module.exports = __webpack_public_path__ + "assets/img/logo.16c69045.png";